import React from "react";
import {firstLetters, ImgComponent} from "src/utils/utility";
import {Col} from "antd"

function QuestionMobile(props){

    const {firstName, lastName, email, record} = props

    return(
        <div>
            <Col span={24} className="flex-center">
                <div className="merriWeather size-16 weight-700 padding-bottom-24">Stai per candidarti a questa offerta</div>
            </Col>
            <Col span={24}>
                <div className="width-100">
                    <div className="flex-row-center">
                        <div className="left-point-button">
                            <div className="left-point-button-inner flex-center">
                                <div className="flex-column flex-center">
                                    <div className="avatar weight-700 size-10 flex-center margin-bottom-5">{firstLetters(firstName,lastName)}</div>
                                    <div className="title padding-5">{firstName + " " + lastName}</div>
                                    <div className="subtitle padding-5">{email}</div>
                                </div>
                            </div>
                        </div>
                        <div className="right-point-button">
                            <div className="right-point-button-inner flex-center">
                                <div className="flex-column flex-center">
                                    <div style={{width: "40px", height: "30px", border: "1px solid rgba(14, 14, 44, 0.15)"}}>
                                        {!record.anonymous ?
                                        <ImgComponent logoPath={record.company.logoPath}/> :
                                        <div className="imgBorder bg-grey">
                                            <div className="flex-center weight-700 size-14 opacity-50" style={{lineHeight: "60px"}}>No foto</div>
                                        </div>}
                                    </div>
                                    <div className="title padding-5">{record.title}</div>
                                    {record.anonymous ?
                                    <div className="opacity-50 underlined size-12">
                                        Azienda Anonima
                                    </div> :
                                    <div className="subtitle padding-5">{record.company.companyName}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </div>

    )
}

export default QuestionMobile